interface Ledger {
  ledger: string;
  _id: string;
}

interface Expense {
  ledger: Ledger;
  remark?: string;
  amount: number;
  date: string;
  month: string;
  year: string;
  createdAt: string;
  updatedAt: string;
  _id: string;
  __v: number;
}

function useSearchExpanse(allExpanses: Expense[], searchTerm: string, filteredExpenses: string | null) {
    
    const filterBySearchTerm = allExpanses
      ?.filter((expanse: Expense) => {
        const matchesSearch =
          expanse?.ledger?.ledger
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          expanse.remark?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          expanse.amount.toString().includes(searchTerm);

        const matchesCategory =
          !filteredExpenses || expanse.ledger._id === filteredExpenses;

        return matchesSearch && matchesCategory;
      })
      .reverse();

      return {filterBySearchTerm};

  };


export default useSearchExpanse
